/*
  Selects the variant option(s) that a gallery thumbnail belongs to.

  The theme already moves the gallery to a variant's featured media when an
  option is picked. This does the reverse: clicking a thumbnail checks the
  option value(s) of the variant(s) that use that media as their featured
  media, and lets the regular `variant-selects` change flow take over.

  Only option values shared by every variant featuring that media are applied,
  so on a Color + Size product clicking an image sets the color and leaves the
  shopper's size alone.
*/
(() => {
  if (window.variantMediaSyncInitialized) return;
  window.variantMediaSyncInitialized = true;

  const AMBIGUOUS = null;

  const getMediaOptionsMap = (gallery) => {
    if (gallery.variantMediaMap) return gallery.variantMediaMap;

    const dataScript = gallery.querySelector('script[data-variant-media-map]');
    if (!dataScript) return null;

    let entries;
    try {
      entries = JSON.parse(dataScript.textContent);
    } catch (error) {
      console.error('variant-media-sync: unable to parse media map', error);
      return null;
    }

    const map = new Map();
    entries.forEach(({ media, options }) => {
      if (!media || !Array.isArray(options)) return;

      const key = String(media);
      const known = map.get(key);
      if (!known) {
        map.set(key, options.slice());
        return;
      }

      // Media shared by several variants only determines the options they agree on.
      options.forEach((value, index) => {
        if (known[index] !== value) known[index] = AMBIGUOUS;
      });
    });

    gallery.variantMediaMap = map;
    return map;
  };

  const selectOptionValues = (productInfo, optionValues) => {
    const variantSelects = productInfo.querySelector('variant-selects');
    if (!variantSelects) return;

    const optionGroups = variantSelects.querySelectorAll(':scope > .product-form__input');
    let lastChanged = null;

    optionValues.forEach((value, index) => {
      if (value === AMBIGUOUS || value === undefined) return;

      const group = optionGroups[index];
      if (!group) return;

      const select = group.querySelector('select');
      if (select) {
        const option = Array.from(select.options).find((option) => option.value === value);
        if (!option || option.selected) return;
        select.value = value;
        lastChanged = select;
        return;
      }

      const input = Array.from(group.querySelectorAll('input[type="radio"]')).find((input) => input.value === value);
      if (!input || input.checked) return;
      input.checked = true;
      lastChanged = input;
    });

    if (lastChanged) lastChanged.dispatchEvent(new Event('change', { bubbles: true }));
  };

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    const thumbnail = target.closest('.product__thumbs-item[data-target]');
    if (!thumbnail) return;

    const gallery = thumbnail.closest('media-gallery');
    const productInfo = gallery && gallery.closest('product-info');
    if (!productInfo) return;

    const mediaOptionsMap = getMediaOptionsMap(gallery);
    if (!mediaOptionsMap) return;

    const optionValues = mediaOptionsMap.get(String(thumbnail.dataset.target));
    if (!optionValues) return;

    selectOptionValues(productInfo, optionValues);
  });
})();
